// src/modules/app-views/products/pages/Init/components/tableColumns/descriptionColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************
const DESCRIPTION_COLUMN_MAX_WIDTH = 350;

const LINE_CLAMP_1 = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  overflow: 'hidden',
  wordBreak: 'break-all',
};

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function descriptionWithPhotoColumn(buildColumnProps, options = {}) {
  const {
    key = 'shortDescription',
    title = 'description',
    dataIndex = 'shortDescription',
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width: DESCRIPTION_COLUMN_MAX_WIDTH,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => (
      <div className="d-flex flex-column">
        <Tooltip title={r?.name || r?.shortDescription}>
          <span className="font-weight-semibold" style={LINE_CLAMP_1}>
            {r?.name || r?.shortDescription || null}
          </span>
        </Tooltip>
        <span className="text-muted" style={LINE_CLAMP_1}>
          {r?.shortDescription || r?.description || null}
        </span>
      </div>
    ),
  };
}

export default descriptionWithPhotoColumn;
